import { takeEvery, takeLatest } from 'redux-saga/effects';
import { INTEGRATION_MODULE } from '../../../configs/moduleNames';
import {
  ARCHIVE_CHECK_TYPES, CREATE_CHECK_TYPES, CREATE_FILE_EXPORT, DELETE_CHECK_TYPES,
  EDIT_CHECK_TYPES_BY_ID, EDIT_FILE_EXPORT_BY_ID,
  EDIT_MAIS_EGU_BY_ID, EXPORT_MAIS_EGU_BY_ID,
  LOAD_CHECK_TYPES_BY_ID,
  LOAD_CHECK_TYPES_LIST, LOAD_CHECKS_BY_ID, LOAD_CHECKS_LIST, LOAD_FILE_EXPORT_BY_ID, LOAD_FILE_EXPORT_LIST,
  LOAD_MAIS_EGU_BY_ID,
  LOAD_MAIS_EGU_LIST,
  LOAD_MAIS_EGU_LOGS_LIST, UNARCHIVE_CHECK_TYPES,
} from '../actions';

import loadMaisEguList from './loadMaisEguList';
import loadMaisEguById from './loadMaisEguById';
import editMaisEguById from './editMaisEguById';
import loadMaisEguLogsList from './loadMaisEguLogsList';
import loadCheckTypesList from './loadCheckTypesList';
import loadCheckTypesById from './loadCheckTypesById';
import archiveCheckTypes from './archiveCheckTypes';
import unarchiveCheckTypes from './unarchiveCheckTypes';
import createCheckTypes from './createCheckTypes';
import deleteCheckTypes from './deleteCheckTypes';
import loadChecksById from './loadChecksById';
import loadChecksList from './loadChecksList';
import loadFileExportById from './loadFileExportById';
import loadFileExportList from './loadFileExportList';
import createFileExport from './createFileExport';
import editFileExportById from './editFileExportById';
import editCheckTypesById from './editCheckTypesById';
import exportMaisEguById from './exportMaisEguById';

export default function* watchDashboard() {
  yield takeEvery(INTEGRATION_MODULE + LOAD_MAIS_EGU_LIST, loadMaisEguList);
  yield takeEvery(INTEGRATION_MODULE + LOAD_MAIS_EGU_BY_ID, loadMaisEguById);
  yield takeEvery(INTEGRATION_MODULE + EXPORT_MAIS_EGU_BY_ID, exportMaisEguById);
  yield takeEvery(INTEGRATION_MODULE + EDIT_MAIS_EGU_BY_ID, editMaisEguById);
  yield takeEvery(INTEGRATION_MODULE + LOAD_MAIS_EGU_LOGS_LIST, loadMaisEguLogsList);
  yield takeLatest(INTEGRATION_MODULE + LOAD_CHECK_TYPES_LIST, loadCheckTypesList);
  yield takeEvery(INTEGRATION_MODULE + LOAD_CHECK_TYPES_BY_ID, loadCheckTypesById);
  yield takeEvery(INTEGRATION_MODULE + EDIT_CHECK_TYPES_BY_ID, editCheckTypesById);
  yield takeEvery(INTEGRATION_MODULE + ARCHIVE_CHECK_TYPES, archiveCheckTypes);
  yield takeEvery(INTEGRATION_MODULE + UNARCHIVE_CHECK_TYPES, unarchiveCheckTypes);
  yield takeEvery(INTEGRATION_MODULE + CREATE_CHECK_TYPES, createCheckTypes);
  yield takeEvery(INTEGRATION_MODULE + DELETE_CHECK_TYPES, deleteCheckTypes);
  yield takeLatest(INTEGRATION_MODULE + LOAD_CHECKS_LIST, loadChecksList);
  yield takeEvery(INTEGRATION_MODULE + LOAD_CHECKS_BY_ID, loadChecksById);
  yield takeEvery(INTEGRATION_MODULE + LOAD_FILE_EXPORT_LIST, loadFileExportList);
  yield takeEvery(INTEGRATION_MODULE + LOAD_FILE_EXPORT_BY_ID, loadFileExportById);
  yield takeEvery(INTEGRATION_MODULE + CREATE_FILE_EXPORT, createFileExport);
  yield takeEvery(INTEGRATION_MODULE + EDIT_FILE_EXPORT_BY_ID, editFileExportById);
}
